import { render, staticRenderFns } from "./AddTermin.vue?vue&type=template&id=fca92e82"
import script from "./AddTermin.vue?vue&type=script&lang=js"
export * from "./AddTermin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports